import React from 'react';
import './PasswordInput.css';
import PropTypes from 'prop-types';
import { ENGLISH } from '../../shared/supportedLanguages';

class PasswordInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      code: '',
      submitted: false,
    };
  }

  handleCodeChange = ({ target: { value: code } }) => {
    this.setState(() => ({ code }));
  };

  handleSubmit = event => {
    event.preventDefault();
    const encoded = window.btoa(this.state.code);
    this.props.context.sendPostBack(encoded);
    this.setState(() => ({ submitted: true }));
    this.props.handlePasswordSubmit();
  };

  render() {
    const {
      state: { code, submitted },
      props,
      handleSubmit,
      handleCodeChange,
    } = this;

    return (
      <form
        dir={props.language === ENGLISH ? '' : 'rtl'}
        style={{ textAlign: props.language === ENGLISH ? '' : 'right' }}
        className="password-input"
        onSubmit={handleSubmit}
      >
        <label>
          <span dir={props.language === ENGLISH ? '' : 'rtl'}
            style={{ textAlign: props.language === ENGLISH ? '' : 'right' }}
          >
            {props.promptMessage}
          </span>
          <input
            autoFocus={true}
            disabled={submitted}
            onChange={handleCodeChange}
            type={'password'}
            placeholder={props.passwordPlaceholder}
            value={code}
            dir={props.language === ENGLISH ? '' : 'rtl'}
            style={{ textAlign: props.language === ENGLISH ? '' : 'right' }}
          />
        </label>
      </form>
    );
  }
}

PasswordInput.propTypes = {
  promptMessage: PropTypes.string.isRequired, 
  passwordPlaceholder: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired
};

export default PasswordInput